import {useEffect} from 'react'

import useFetch from 'shared/model/useFetch'

const useGetVersion = () => {
	const [fetchResult, fetchRequest] = useFetch()
	useEffect(() => {
		fetchRequest('GET', `/admin/version`)
	}, [])

	return [fetchResult]
}

export default useGetVersion
